$( document ).ready(function() {
    $('#search-input-header').on("keyup", function(){
      console.log( "ready!", $(this).val() );
      let searchParam = $(this).val();
      if(searchParam.trim()==""){
          $("#search-result-div-container").css("display", "none");
          $("#search-result-div-container").css("height", "0px");
      }else{
          $("#search-result-div-container").css("display", "block");
          $("#search-result-div-container").css("height", "200px");

          let collectionTitleContainer = $("#collection-list-container").find(".search-flydown--product-title");
          for(let i = 0; i < collectionTitleContainer.length; i++){
              let collectionName = $(collectionTitleContainer[i]).text().toLowerCase();
              if(collectionName.indexOf(searchParam.toLowerCase()) != -1){
                $(collectionTitleContainer[i]).parents(".search-flydown--product").show();
              } else {
                $(collectionTitleContainer[i]).parents(".search-flydown--product").hide();
              }
             console.log("collectionTitleContainer", $(collectionTitleContainer[i]).text());
          }
      }
    });
  $('.live-search-form').on('keyup keypress', function(e) {
  var keyCode = e.keyCode || e.which;
  if (keyCode === 13) { 
    e.preventDefault();
    return false;
  }
});
});